import { useState, useEffect } from 'react';

import { useThemeUI } from '@tishman/components';

/**
 * A custom hook that tracks whether the viewport is in mobile view.
 * It uses the first breakpoint from the theme as the mobile breakpoint.
 */
export function useMobileView() {
  const { theme } = useThemeUI();
  const mobileBreakpoint = parseInt(theme?.breakpoints?.[0] || '640px', 10);

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined'
      ? window.innerWidth <= mobileBreakpoint
      : false,
  );

  useEffect(() => {
    function handleWindowResize(e: MediaQueryList | MediaQueryListEvent) {
      if ('matches' in e) {
        setIsMobile(e.matches);
      }
    }

    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia(
        `(max-width: ${mobileBreakpoint}px)`,
      );
      mediaQuery.addEventListener('change', handleWindowResize as any);
      handleWindowResize(mediaQuery);

      return () =>
        mediaQuery.removeEventListener('change', handleWindowResize as any);
    }
  }, [mobileBreakpoint]);

  return isMobile;
}
